/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * mongodb API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV8MongodbActiveSessionByInstanceIdParams,
  GetV8MongodbActiveSessionSqlTextParams,
  GetV8MongodbShardClusterActiveSessionByInstanceIdParams,
  MongodAciveSessionResponse,
  MongondbClusterMapResponse,
  MongosActiveSessionResponse,
  PostV8MongodbSessionsKillSessionByInstanceIdParams,
  SqlTextResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Active Session Full Text 조회
 */
export const getV8MongodbActiveSessionSqlText = (
  params: MaybeRef<GetV8MongodbActiveSessionSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextResponse>(
    {
      url: `/api/v8/mongodb/active-session/sql-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8MongodbActiveSessionSqlTextQueryKey = (
  params?: MaybeRef<GetV8MongodbActiveSessionSqlTextParams>,
) => {
  return [
    'api',
    'v8',
    'mongodb',
    'active-session',
    'sql-text',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8MongodbActiveSessionSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MongodbActiveSessionSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MongodbActiveSessionSqlTextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>> = ({
    signal,
  }) => getV8MongodbActiveSessionSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>,
    TError,
    TData
  >;
};

export type GetV8MongodbActiveSessionSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>
>;
export type GetV8MongodbActiveSessionSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary Active Session Full Text 조회
 */

export function useGetV8MongodbActiveSessionSqlText<
  TData = Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8MongodbActiveSessionSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MongodbActiveSessionSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MongodbActiveSessionSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Mongos Active Session 조회
 */
export const getV8MongodbShardClusterActiveSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbShardClusterActiveSessionByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<MongosActiveSessionResponse>(
    {
      url: `/api/v8/mongodb/shard-cluster/${instanceId}/active-session`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8MongodbShardClusterActiveSessionByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbShardClusterActiveSessionByInstanceIdParams>,
) => {
  return [
    'api',
    'v8',
    'mongodb',
    'shard-cluster',
    instanceId,
    'active-session',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8MongodbShardClusterActiveSessionByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbShardClusterActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MongodbShardClusterActiveSessionByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>
  > = ({ signal }) =>
    getV8MongodbShardClusterActiveSessionByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MongodbShardClusterActiveSessionByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>
>;
export type GetV8MongodbShardClusterActiveSessionByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Mongos Active Session 조회
 */

export function useGetV8MongodbShardClusterActiveSessionByInstanceId<
  TData = Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbShardClusterActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MongodbShardClusterActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MongodbShardClusterActiveSessionByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Mongod Active Session 조회
 */
export const getV8MongodbActiveSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbActiveSessionByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<MongodAciveSessionResponse>(
    {
      url: `/api/v8/mongodb/${instanceId}/active-session`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8MongodbActiveSessionByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbActiveSessionByInstanceIdParams>,
) => {
  return [
    'api',
    'v8',
    'mongodb',
    instanceId,
    'active-session',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8MongodbActiveSessionByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MongodbActiveSessionByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>
  > = ({ signal }) =>
    getV8MongodbActiveSessionByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MongodbActiveSessionByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>
>;
export type GetV8MongodbActiveSessionByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Mongod Active Session 조회
 */

export function useGetV8MongodbActiveSessionByInstanceId<
  TData = Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8MongodbActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8MongodbActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MongodbActiveSessionByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Cluster Map 조회
 */
export const getV8MongodbClusterMapByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<MongondbClusterMapResponse>(
    { url: `/api/v8/mongodb/${instanceId}/cluster/map`, method: 'GET', signal },
    options,
  );
};

export const getGetV8MongodbClusterMapByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v8', 'mongodb', instanceId, 'cluster', 'map'] as const;
};

export const getGetV8MongodbClusterMapByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8MongodbClusterMapByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>> = ({
    signal,
  }) => getV8MongodbClusterMapByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8MongodbClusterMapByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>
>;
export type GetV8MongodbClusterMapByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Cluster Map 조회
 */

export function useGetV8MongodbClusterMapByInstanceId<
  TData = Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8MongodbClusterMapByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8MongodbClusterMapByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary killSession
 */
export const postV8MongodbSessionsKillSessionByInstanceId = (
  params: MaybeRef<PostV8MongodbSessionsKillSessionByInstanceIdParams>,
  instanceId: MaybeRef<string> = '276',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<string>(
    {
      url: `/api/v8/mongodb/${instanceId}/sessions/kill-session`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8MongodbSessionsKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>,
    TError,
    { params: PostV8MongodbSessionsKillSessionByInstanceIdParams; instanceId?: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV8MongodbSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationKey = ['postV8MongodbSessionsKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>,
    { params: PostV8MongodbSessionsKillSessionByInstanceIdParams; instanceId?: string }
  > = (props) => {
    const { params, instanceId } = props ?? {};

    return postV8MongodbSessionsKillSessionByInstanceId(params, instanceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8MongodbSessionsKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>
>;

export type PostV8MongodbSessionsKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary killSession
 */
export const usePostV8MongodbSessionsKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>,
      TError,
      { params: PostV8MongodbSessionsKillSessionByInstanceIdParams; instanceId?: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8MongodbSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV8MongodbSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationOptions = getPostV8MongodbSessionsKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
